import React, {useState, useEffect} from 'react';
import * as C from '../Common.styles';
import {validations} from '../../../../utils/validations';
import {sendEvarData} from '@ibibo/analytics';

import ButtonLoader from '../../UI/Loader/Loader';
import {NON_EDITABLE_STATUS} from '../../../../constants';

const UserInfoUI = ({userInfo, apiError, onSubmitUserInfo, setLoader, status, directLanding}) => {
  const [
    {title, full_name, country_code, mobile, email},
    setUserInfo,
  ] = useState({
    title: userInfo.title || '',
    full_name: userInfo.fullName || '',
    mobile: userInfo.mobile || '',
    email: userInfo.email || '',
    country_code: userInfo.countryCode || '+91'
  });

  const [apiErrorMsg, setApiError] = useState(apiError);
  const [errors, setError] = useState({});

  useEffect(() => {
    setApiError(apiError);
  }, [apiError]);

  useEffect(() => {
    setUserInfo({
      title: userInfo.title || title,
      full_name: userInfo.fullName || full_name,
      mobile: userInfo.mobile || mobile,
      email: userInfo.email || '',
      country_code: userInfo.countryCode || country_code
    });
  }, [directLanding])

  const fieldValidators = {
    'title': {'field': 'title', 'fieldName': 'Title', 'validators': ['required']},
    'full_name': {'field': 'firstName', 'fieldName': 'Name', 'validators': ['required', 'alpha']},
    'email': {'field': 'email', 'fieldName': 'Email', 'validators': ['required', 'validEmail']},
    'mobile': {'field': 'mobile', 'fieldName': 'Mobile Number', 'validators': ['required', 'validMobileNumber']},
    'country_code': {'field': 'mobilecode', 'fieldName': 'Mobile Code', 'validators': ['required', 'validMobileCode']},
  };

  const validateFields = (data) => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const resp = validateFunction({
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
            countryCode: country_code
          });
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  }

  const submitUserInfo = (event: React.FormEvent) => {
    event.preventDefault();
    const data = {
      title,
      full_name,
      email,
      country_code,
      mobile
    };
    const hasError = validateFields(data);
    if (!hasError) {
      onSubmitUserInfo(data);
    }

    sendEvarData({
      prop54: "myPartner|signup|personalDetails|next"
    }, true)
  };

  const onChangeHandler = (field, value) => {

    if (field === 'mobile') {
      const re = /^[0-9]+$/;
      if (value !== '' && !re.test(value)) {
        return;
      }
    }
    const data = {
      title,
      full_name,
      email,
      mobile,
      country_code
    };
    data[field] = value;
    setUserInfo(data);
  }

  return (
    <C.FormMainWrapper>
      <C.WelcomeHeadText>Signup & get started!</C.WelcomeHeadText>
      <C.HeadSubText>Start your myPartner journey in just 3 simple steps.</C.HeadSubText>
      <C.FormWrapper>
        <C.UserInfoForm onSubmit={submitUserInfo}>
          <C.BlockWrapper disabled={NON_EDITABLE_STATUS.indexOf(status) !== -1}>
            <C.InputWrapper>
              <C.TitleWrapper>
                <C.CommonSelect
                  value={title}
                  onChange={event => onChangeHandler('title', event.target.value)}
                  hasError={errors['title'] ? true : false}>
                  <option value="">Title</option>
                  <option value="1">Mr.</option>
                  <option value="2">Mrs.</option>
                  <option value="3">Ms.</option>
                </C.CommonSelect>
                <C.ErrorText>{errors['title']}</C.ErrorText>
              </C.TitleWrapper>
              <C.FullNameWrapper>
                <C.CommonInput
                  type="text"
                  placeholder="Your Full Name"
                  name="fullname"
                  value={full_name}
                  onChange={event => onChangeHandler('full_name', event.target.value)}
                  hasError={errors['full_name'] ? true : false}
                />
                <C.ErrorText>{errors['full_name']}</C.ErrorText>
              </C.FullNameWrapper>
            </C.InputWrapper>
            
            <C.InputWrapper>
              <C.EmailWrapper>
                <C.CommonInput
                  type="text"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={event => onChangeHandler('email', event.target.value)}
                  hasError={errors['email'] ? true : false}
                />
                <C.ErrorText>{errors['email']}</C.ErrorText>
              </C.EmailWrapper>
            </C.InputWrapper>
            
            <C.InputWrapper>
              <C.TitleWrapper>
                <C.CommonInput
                  type="text"
                  name="code"
                  value={country_code}
                  placeholder="+91"
                  disabled
                />
              </C.TitleWrapper>
              <C.FullNameWrapper>
                <C.CommonInput
                  type="text"
                  placeholder="Mobile Number"
                  name="mobile"
                  value={mobile}
                  onChange={event => onChangeHandler('mobile', event.target.value)}
                  hasError={errors['mobile'] ? true : false}
                  maxLength="10"
                />
                <C.ErrorText>{errors['mobile']}</C.ErrorText>
              </C.FullNameWrapper>
            </C.InputWrapper>
            <C.ApiErrorText>{apiErrorMsg && apiErrorMsg.screen === 'home' ? apiErrorMsg.msg : ''}</C.ApiErrorText>
          </C.BlockWrapper>

          <C.ButtonWrapper>
            <C.SignUpBtn type="submit" > {setLoader ? <ButtonLoader loaderType="button"/> : 'NEXT'}</C.SignUpBtn>
          </C.ButtonWrapper>
        </C.UserInfoForm>
      </C.FormWrapper>
    </C.FormMainWrapper>
  );
};

export default UserInfoUI;
